import "../../css/dashboardIA.css";

// Badge de estado — matriz de `Status.pdf` (skill cloudprojects-branding §4), dos énfasis.
// SIEMPRE ícono + etiqueta (RF-22/RF-16/CA-12): el color nunca es el único canal, así que sigue siendo
// distinguible en escala de grises. `rol` es uno de los cinco reservados (nunca se usa para una categoría
// de gráfica, RF-29): info | ok | warn | alert | neutral. `emphasis`: "bajo" (tinte, el normal en tablas)
// o "alto" (sólido, solo para lo que debe interrumpir la lectura — el semáforo crítico).
const EstadoBadge = ({ rol = "neutral", emphasis = "bajo", icon, label }) => (
  <span className={`dia-badge dia-badge--${rol} dia-badge--${emphasis}`}>
    {icon && <i className={`fa ${icon}`} aria-hidden="true"></i>}
    <span>{label}</span>
  </span>
);

export default EstadoBadge;
